import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import LoadingSpinner from "../components/LoadingSpinner";

export default function ProtectedRoute({ children }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const isLoading = useSelector((state) => state.auth.isLoading);
  const location = useLocation();

  if (isLoading) return <LoadingSpinner />; // Show loader

  if (!isAuthenticated) {
    // Redirect to /auth and store the current location for redirect after login
    return <Navigate to="/auth/sign-in" state={{ from: location }} replace />;
  }

  return children;
}
